import axios from 'axios'
import { ref } from 'vue';
import { defineStore, acceptHMRUpdate } from 'pinia';
import { useUserStore } from './user';

const instance = axios.create({
	baseURL: 'https://laravel.heartmanagement.fr/api/',
})

export const useCloudStore = defineStore('cloud-store', () => {    
	const userStore = useUserStore();
	
    const getDocuments = (id) => {
        return new Promise((resolve, reject) => {
			instance({
				url: `cloud`,
				method: 'GET',
				headers: {
                    Authorization: `Bearer ${userStore.userLog.token}`
                }
			})
            .then(res => {
				resolve(res.data);
            })
            .catch(err => {
				reject(err);
            })
		})
    }

	const addDocuments = (payload) => {
		return new Promise((resolve, reject) => {

			instance({
				url: `cloud`,
				method: 'POST',
				data: payload,
				headers: {
                    Authorization: `Bearer ${userStore.userLog.token}`
                }
			})
            .then(res => {
				resolve(res.data);
            })
            .catch(err => {
				reject(err);
            })
		})
	}

	const deleteDocument = (docname, id) => {
		return new Promise((resolve, reject) => {
			instance({
				url: `cloud/${id}/delete`,
				method: 'POST',
				data: {
					filename: docname
				},
				headers: {
                    Authorization: `Bearer ${userStore.userLog.token}`
                }
			})
            .then(res => {
				resolve(res.data);
            })
            .catch(err => {
				reject(err);
            })
		})
	}

	return {
		// Variables
		// Functions
        getDocuments,
		addDocuments,
		deleteDocument,
	}
}, { persistedState: { persist: true } })

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCloudStore, import.meta.hot));
}
